module.exports = __webpack_public_path__ + "img/uservoice-title.5909f36b.svg";